module.exports = __webpack_public_path__ + "img/PL00243.d83cd638.png";